class MobileLayoutSwitcher extends HTMLElement {
  constructor() {
    super();
    this.switcherButtons = this.querySelectorAll('.button');
  }

  connectedCallback() {
    if (this.switcherButtons.length === 0) return;

    // Set default layout to 1 column on mobile
    if (this.productGrid && !this.productGrid.classList.contains('grid--1-col-mobile')) {
      this.productGrid.classList.add('grid--1-col-mobile');
    }

    this.switcherButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const productGrid = this.productGrid;
        if(!productGrid) return;

        const selectedLayout = button.classList.contains('col-1') ? 'grid--1-col-mobile' : '';

        // Remove existing layout classes
        productGrid.classList.remove('grid--1-col-mobile');
        // Add the selected layout class
        if(selectedLayout) productGrid.classList.add(selectedLayout);

        // Update button states
        this.switcherButtons.forEach(button => button.classList.remove('selected'));
        button.classList.add('selected');
      });
    });
  }

  get productGrid() {
    return document.querySelector('.collection .product-grid');
  }
}

if (!customElements.get('mobile-layout-switcher')) {
  customElements.define("mobile-layout-switcher", MobileLayoutSwitcher);
}